import React, { useEffect } from 'react';
import LoginForm from 'components/authentication/LoginForm';
import routes, { peltaskRoutes, peltaskAdminRoutes, pharmacyAdminRoutes, reportRoutes, Rout4MeRoutes, orderHistoryRoutes, patientRoutes, masterRoutes, MedpassRoutes, drugListRoute, Resources } from 'routes/siteMaps';
import AuthSplitLayout from 'layouts/AuthSplitLayout';
import bgImg from 'assets/img/generic/21.jpeg';
import Flex from 'components/common/Flex';
import AuthSplitLayoutLogin from 'layouts/AuthSplitLayoutLogin';
import { useUnsavedChanges } from 'components/prescription/UnsavedChangesContext';
import { toast } from 'react-toastify';

const Login = () => {

  //cleanupactivity todo better way to right this
  const { setIsDirty } = useUnsavedChanges();
  setIsDirty(false);

  const sessionMessage = localStorage.getItem('session_message');
  localStorage.clear();
  if (sessionMessage) {
    localStorage.setItem('session_message', sessionMessage);
  }

  useEffect(() => {
    const pendingSessionMessage = localStorage.getItem('session_message');
    if (pendingSessionMessage) {
      toast.warning(pendingSessionMessage, {
        theme: 'colored'
      });
      localStorage.removeItem('session_message');
    }
  }, []);

  if (routes.includes(peltaskRoutes)) {
    const index = routes.indexOf(peltaskRoutes);
    routes.splice(index, 1);
  }

  if (routes.includes(peltaskAdminRoutes)) {
    const index = routes.indexOf(peltaskAdminRoutes);
    routes.splice(index, 1);
  }

  if (routes.includes(pharmacyAdminRoutes)) {
    const index = routes.indexOf(pharmacyAdminRoutes);
    routes.splice(index, 1);
  }

  if(routes.includes(Rout4MeRoutes)){
    const index = routes.indexOf(Rout4MeRoutes);
    routes.splice(index, 1);
  }

  if(routes.includes(patientRoutes)){
    const index = routes.indexOf(patientRoutes);
    routes.splice(index, 1);
  }

  if(routes.includes(masterRoutes)){
    const index = routes.indexOf(masterRoutes);
    routes.splice(index, 1);
  }

  if(routes.includes(reportRoutes)){
    const index = routes.indexOf(reportRoutes);
    routes.splice(index, 1);
  }

  if(routes.includes(orderHistoryRoutes)){
    const index = routes.indexOf(orderHistoryRoutes);
    routes.splice(index, 1);
  }

  if(routes.includes(MedpassRoutes)){
    const index = routes.indexOf(MedpassRoutes);
    routes.splice(index, 1);
  }
  if(routes.includes(Resources)){
    const index = routes.indexOf(Resources);
    routes.splice(index, 1);
  }


  return (
    <AuthSplitLayoutLogin bgProps={{ image: bgImg, position: 'center bottom', style: { aspectRatio: '960/1080' } }}>
      {/* <div className="festive-banner">
        <span className="festive-disco-text">
          Mapyourmeds Wishes You A Merry Christmas & Happy Holidays 🎄
        </span>
      </div> */}
      <Flex alignItems="center" justifyContent="between">
        <h3>Login</h3>
        {/*<p className="mb-0 fs-10">
          <span className="fw-semibold">New User? </span>
          <Link to={paths.splitRegister}>Create account</Link>
        </p>*/}
      </Flex>
      <LoginForm layout="split" hasLabel />
    </AuthSplitLayoutLogin>
  );
};

export default Login;
